import React from 'react';
import LeadManagement from './LeadManagement';

const LeadManagementPage: React.FC = () => {
  return <LeadManagement />;
};

export default LeadManagementPage;